<template>
<div class="video" @click="playVideo()">

  <div class="video-overlay" v-if="isPlaying">
    <iframe :src="videoSrc" id="myFrame" frameborder="0" scrolling="0" allow="autoplay; encrypted-media;" v-if="isPlaying&&videoSrc"></iframe>
  </div>
  <div class="video-play" v-if="!isPlaying"></div>

  <img :src="thumbnailUrl" alt="" v-if="thumbnailUrl">

</div>
</template>

<script>
export default {
  name: "VideoEmbed",
  data() {
    return {
      isPlaying: false
    };
  },
  props: {
    videoId: String,
    thumbnailUrl: String
  },
  computed: {

    videoSrc: function() {
      return 'https://www.youtube.com/embed/' + this.videoId + '?rel=0&showinfo=0&autoplay=1';
    }

  },
  methods: {

    playVideo() {

      var videoSrc = 'https://www.youtube.com/embed/' + this.videoId + '?rel=0&showinfo=0&autoplay=1';

      this.isPlaying = true;

      // var ifrm = document.createElement('iframe');
      // ifrm.setAttribute('src', videoSrc);
      // ifrm.style.width = "640px";
      // ifrm.style.height = "480px";
      // document.body.appendChild(ifrm);

    },

  },
};
</script>

<style scoped>
</style>